import DeleteModal from '@/components/Modals/DeleteModal';
import { useRefetchPresentersList } from '@/hooks';
import { useDeleteImage } from '@/hooks/useDeleteImage';
import { useAdvancedEditorContext } from '@/pages/AdvancedEditor/context/useAdvancedEditorContext';
import { PolotnoStoreActivePageKeys, usePolotnoActivePageState } from '@/pages/AdvancedEditor/hooks';
import { getAvatarElementFromPage } from '@/pages/AdvancedEditor/utils';
import { ImageType } from '@d-id/types';
import { observer } from 'mobx-react-lite';
import { useCallback } from 'react';

export const DeleteAvatarModal = observer(() => {
    const { store, presenterToDelete, setPresenterToDelete } = useAdvancedEditorContext();
    const [selectedPresenterType] = usePolotnoActivePageState(PolotnoStoreActivePageKeys.selectedPresenterType);
    const [selectedPresenter, setSelectedPresenter] = usePolotnoActivePageState(PolotnoStoreActivePageKeys.selectedPresenter);

    const { mutateAsync: deletePresenter, isLoading: isDeletingPresenter } = useDeleteImage(selectedPresenterType);
    const { mutateAsync: deleteCustomDream, isLoading: isDeletingCustomDream } = useDeleteImage(ImageType.Dreams);
    const { refetchPresentersList } = useRefetchPresentersList();

    const deleteAvatar = useCallback(async () => {
        if (!presenterToDelete?.id) {
            return;
        }

        presenterToDelete.presenterType == ImageType.Dreams && selectedPresenterType === ImageType.Upload
            ? await deleteCustomDream(presenterToDelete.id)
            : await deletePresenter(presenterToDelete.id);

        if (selectedPresenter === presenterToDelete.id) {
            setSelectedPresenter('');
        }

        const avatar = getAvatarElementFromPage(store.activePage);
        if (avatar) {
            store.deleteElements([avatar.id]);
        }
        refetchPresentersList();
    }, [presenterToDelete, deletePresenter, deleteCustomDream, store, selectedPresenter]);

    return (
        <DeleteModal
            itemType="image"
            mode="square"
            open={!!presenterToDelete}
            isLoading={isDeletingPresenter || isDeletingCustomDream}
            onDelete={deleteAvatar}
            onClose={() => setPresenterToDelete(undefined)}
            poster={presenterToDelete?.thumbnail ?? ''}
            text={{
                title: 'Delete Avatar?',
                content: 'Are you sure you want to delete this Avatar?',
                cta: 'Delete Avatar',
            }}
        />
    );
});
